import $ from 'jquery';

const showHideButtons = $('.show-hide-text__button');

showHideButtons.each(function(index, element) {
    $(element).on('click', function() {
        $(element).prev('.show-hide-text__content').slideToggle('fast');
        $(element).toggleClass('flip-arrow');

        const elementText = $(element).find('span');

        elementText.text(elementText.text() === 'Rozwiń więcej' ? 'Zwiń' : 'Rozwiń więcej');
    });
});